export enum EContentGeneratorStylesForm {
  STYLE = 'STYLE',
}
